import request from "./../utils/request";

export function getCatalog(id) {
    return request({
        url: id ? `/catalog/${id}` : `/catalog/`,
        method: "get",
    });
}

export function createCatalog(data) {
    return request({
        url: "/catalog/",
        method: "post",
        data: data,
    });
}

export function updateCatalog(id, data) {
    return request.put(`/catalog/${id}`, data);
}

export function deleteCatalog(id) {
    return request.delete(`/catalog/${id}`);
}
